import { useEffect, useState } from 'react';
import { TimeLogApi } from '../../../api';
import { useContainer } from '../../useContainer';

interface IGetSubmissionIntervalsForMonth {
    userSub: string;
    projectId: string;
    month: string;
    year: number;
}

const useHttpGetSubmissionIntervalsForMonth = (query: IGetSubmissionIntervalsForMonth) => {
    const timeLogApi: TimeLogApi = useContainer(TimeLogApi);
    const [data, setData] = useState<any[]>([]);

    useEffect(() => {
        const { exec, abort } = timeLogApi.getSubmissionIntervalsForMonth({
            query,
            onSuccess: res => {
                setData(res.body);
            },
            onError: error => error,
        });

        if (query) exec();
        return abort;
    }, [JSON.stringify(query)]);

    return { data };
};

export default useHttpGetSubmissionIntervalsForMonth;
